module.exports = __webpack_public_path__ + "static/img/stock-photo-programmer-working-from-home-office-remote-1056727022.d8eb205.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stock-photo-programmer-working-from-home-office-remote-1056727022.jpg
// module id = xiAJ
// module chunks = 1